import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// 供应商权限
interface State {
  setPermission: (permission: string[]) => void
  permissionList: string[]
}

export const usePermissionStore = create<State>()(
  devtools((set) => ({
    permissionList: ['电商供应商', '自营供应商'],
    setPermission(permissionList) {
      set({
        permissionList: permissionList,
      })
    },
  })),
)
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

// 供应商权限
interface State {
  setPermission: (permission: string[]) => void
  permissionList: string[]
}

export const usePermissionStore = create<State>()(
  devtools((set) => ({
    permissionList: ['电商供应商', '自营供应商'],
    setPermission(permissionList) {
      set({
        permissionList: permissionList,
      })
    },
  })),
)
